"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var modules_1 = require("./modules");
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#6798C0' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.isSelected, isSelected = _e === void 0 ? false : _e, _f = _a.simple, simple = _f === void 0 ? false : _f, _g = _a.title, title = _g === void 0 ? '' : _g, children = _a.children, _h = _a.viewBox, viewBox = _h === void 0 ? '0 0 32 32' : _h, rest = __rest(_a, ["color", "size", "isDisabled", "isSelected", "simple", "title", "children", "viewBox"]);
    var _j = modules_1.iconSizeMap[size] || modules_1.iconSizeMap.normal, width = _j[0], height = _j[1];
    var svgFillColor = 'none';
    var svgColor = color;
    if (isDisabled) {
        svgFillColor = 'none';
        // TODO: grab gray from theme
        svgColor = '#C5C8CB';
    }
    else if (isSelected && !simple) {
        svgFillColor = color;
        svgColor = '#fff';
    }
    var icon = react_1.default.cloneElement(children, { color: svgColor, isDisabled: isDisabled, isSelected: isSelected });
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, fill: simple ? 'none' : svgFillColor, viewBox: viewBox }, rest, { children: [icon, title ? (0, jsx_runtime_1.jsx)("title", { children: title }) : null] })));
};
exports.Icon = Icon;
